module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pagelist animate fadeIn"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-pagelist"
  }, [_c('h1', {
    staticClass: "header-title text-center"
  }, [_vm._v("โอกาสพิเศษที่อยากให้คุณมีส่วนร่วม")]), _vm._v(" "), _c('h2', {
    staticClass: "sub-title ma-0 text-center"
  }, [_vm._v("ร่วมบริจาคในโอกาสพิเศษและให้โอกาสทางการศึกษาแก่เด็กด้อยโอกาสไปพร้อมกัน")]), _vm._v(" "), _c('router-link', {
    staticClass: "ma-auto btn btn--white",
    attrs: {
      "tag": "button",
      "to": "special-events/pages/create",
      "type": "button"
    }
  }, [_vm._v("บริจาคในโอกาสพิเศษของคุณ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col col-sm-4 flex"
    }, [_c('div', {
      staticClass: "shadow card",
      class: _vm.getCardClasses(item)
    }, [_c('div', {
      staticClass: "card-header",
      style: (_vm.getCardStyle(item))
    }, [_c('router-link', {
      attrs: {
        "to": ("/pages/" + (item.id))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToPage(item)
        }
      }
    }, [_c('div', {
      staticClass: "img-circle",
      style: ({
        backgroundImage: ("url('" + (item.image) + "')")
      })
    })]), _vm._v(" "), (item.data.type === _vm.$const.SPECIAL_EVENT_TYPES.BIRTHDAY) ? _c('h2', {
      staticClass: "card-title"
    }, [_vm._v("Happy Birthday")]) : _vm._e(), _vm._v(" "), (item.data.type === _vm.$const.SPECIAL_EVENT_TYPES.ANNIVERSARY) ? _c('h2', {
      staticClass: "card-title"
    }, [_vm._v("Happy Anniversary")]) : _vm._e(), _vm._v(" "), (item.data.type === _vm.$const.SPECIAL_EVENT_TYPES.OTHER) ? _c('h2', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(item.data.custom_type))]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.data.name)), _c('br'), _vm._v(_vm._s(_vm.getFormattedDate(item)))])], 1), _vm._v(" "), (item.data.message) ? _c('div', {
      staticClass: "card-body"
    }, [_vm._v("\n              " + _vm._s(item.data.message) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('funding-goal', {
      ref: "fundingGoal",
      refInFor: true,
      staticClass: "mb-20",
      attrs: {
        "target": _vm.getDonationTarget(item),
        "amount": _vm.getDonationAmount(item),
        "end-date": item.data.end_date,
        "percent": _vm.getDonationProgress(item)
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "ma-auto btn btn--default btn--full",
      attrs: {
        "tag": "button",
        "to": ("/pages/" + (item.id)),
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToPage(item)
        }
      }
    }, [_vm._v("ร่วมบริจาค")])], 1)])])
  }), 0), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.loaded && _vm.error && !_vm.loading && false) ? _c('div', {
    staticClass: "w-50 ma-auto mt-15 mb-15"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("ไม่พบข้อมูล")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn--white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refresh($event)
      }
    }
  }, [_vm._v("โหลดใหม่อีกครั้ง")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-50 ma-auto mt-15 mb-15"
  }, [(_vm.showLoadMore && _vm.items.length > 0) ? _c('a', {
    staticClass: "btn btn--white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadMore($event)
      }
    }
  }, [_vm._v("ดูเพิ่ม")]) : _vm._e()])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0505dbc9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0505dbc9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/special-events.vue
// module id = 722
// module chunks = 1